import React, { useState, useEffect } from 'react';

import {
  FormContainer,
  Row,
  FormTitle,
  StyledLargeTitle,
  StyledMediumTitle,
  PerconnelCardContainer,
  CloseButton,
} from "../styles";

import Dialog from "@material-ui/core/Dialog";
import Paper from "@material-ui/core/Paper";
import CloseIcon from "@material-ui/icons/Close";
import Input from "../../../components/inputField";
import PersonnelCard from "../components/personnelCard";
import logoModal from "../../../assets/preQualifyIcons/logo_small.svg";
import { LooksGoodButton } from "../components/looksGoodButton";


export const KeySitePersonnelForm = ({
  setActiveStep,
  qualificationData,
  setQualificationData,
  setIsLastPanel,
}) => {
  setIsLastPanel(true);

  const [openDialog, setOpenDialog] = useState(false);
  const [editIndex, setEditIndex] = useState(null);

  const [dialogFN, setDialogFN] = useState("");
  const [dialogLN, setDialogLN] = useState("");
  const [dialogPos, setDialogPos] = useState("");
  const [validSubmit, setValidSubmit] = useState(true);

  const [disabled, setDisabled] = useState(true);

  useEffect(() => {

    if (qualificationData?.key_site?.length > 0) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  });

  useEffect(() => {
    if (dialogFN.length > 0 && dialogLN.length > 0 && dialogPos.length > 0) {
      setValidSubmit(false);
    } else {
      setValidSubmit(true);
    }
  }, [dialogFN, dialogLN, dialogPos]);

  const handleRemovePersonnel = (qualificationData, firstName, lastName, position) => {
    const updatedQualificationData = qualificationData.filter(
      (item) =>
        !(
          item.firstName === firstName &&
          item.lastName === lastName &&
          item.position === position
        )
    );

    setQualificationData('key_site', updatedQualificationData);
  };

  const handleAddPersonnel = () => {
    let updatedPersonnelData = [];

    if (qualificationData?.key_site) {
       updatedPersonnelData = [...qualificationData.key_site];
    }

    updatedPersonnelData.push({
      firstName: dialogFN,
      lastName: dialogLN,
      position: dialogPos,
    });

    setQualificationData('key_site', updatedPersonnelData);
  };

  const handleEditPersonnel = () => {
    let updatedPersonnelData = [];

    if (qualificationData?.key_site) {
       updatedPersonnelData = [...qualificationData.key_site];
    }

    updatedPersonnelData[editIndex] = {
      firstName: dialogFN,
      lastName: dialogLN,
      position: dialogPos,
    };

    setQualificationData('key_site', updatedPersonnelData);
  }

  return (
    <FormContainer>
      <StyledLargeTitle>Key Site Personnel</StyledLargeTitle>
      <StyledMediumTitle> Who are the key site personnel at {qualificationData.project_info ?
                                             qualificationData.project_info.gc_name :
                                             "your company"}?</StyledMediumTitle>
      <PerconnelCardContainer>
        {qualificationData.key_site &&
         qualificationData.key_site.map((item, i) => { if(item.firstName) return (
          <PersonnelCard
            {...item}
            key={i}
            qualificationData={qualificationData.key_site ?
                               qualificationData.key_site :
                               []}
            setPersonnel={handleRemovePersonnel}
            setDialogFN={setDialogFN}
            setDialogLN={setDialogLN}
            setDialogPos={setDialogPos}
            setOpenDialog={setOpenDialog}
            index={i}
            setEditIndex={setEditIndex}
          />
        )})}
        {(!qualificationData.key_site ||
            qualificationData.key_site?.length < 5) && (
            <PersonnelCard
              variant="add"
              onClick={() => setOpenDialog(true)}
            />
          )
        }
      </PerconnelCardContainer>
      <Dialog
        open={openDialog}
        onClose={() => {
          setOpenDialog(false);
          setDialogFN("");
          setDialogLN("");
          setDialogPos("");
          setEditIndex(null);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="md"
      >
        <Paper
          elevation={0}
          style={{
            padding: 25,
            width: 400,
            alignSelf: "center",
            overflow: "hidden",
            position: "relative",
            alignItems: "center",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <CloseButton
            aria-label="close"
            onClick={() => {
              setOpenDialog(false);
              setDialogFN("");
              setDialogLN("");
              setDialogPos("");
              setEditIndex(null);
            }}
          >
            <CloseIcon />
          </CloseButton>
          <img src={logoModal} style={{ width: 65, height: 65 }}></img>
          <FormTitle style={{ marginTop: 10 }}>Add Your Personnel</FormTitle>
          <Row style={{ margin: "0px -10px" }}>
            <Input
              style={{ margin: "0px 10px" }}
              label="First Name*"
              type="text"
              placeholder="First Name"
              value={dialogFN}
              setValue={setDialogFN}
              validateFunc={(item) => item.length > 0}
              noCheckIcon={true}
              noErrorBorder={true}
            />
            <Input
              style={{ margin: "0px 10px" }}
              label="Last Name*"
              type="text"
              placeholder="Last Name"
              value={dialogLN}
              setValue={setDialogLN}
              validateFunc={(item) => item.length > 0}
              noCheckIcon={true}
              noErrorBorder={true}
            />
          </Row>
          <Input
            label="Position*"
            type="text"
            placeholder="Position"
            value={dialogPos}
            setValue={setDialogPos}
            validateFunc={(item) => item.length > 0}
            noCheckIcon={true}
            noErrorBorder={true}
          />
          <LooksGoodButton
            disabled={validSubmit}
            onClick={() => {
              setOpenDialog(false);
              if (editIndex !== null) {
                handleEditPersonnel();
                setEditIndex(null);
              } else {
                handleAddPersonnel();
              };
              setDialogFN("");
              setDialogLN("");
              setDialogPos("");
            }}
          >
            SUBMIT
          </LooksGoodButton>
        </Paper>
      </Dialog>
    </FormContainer>
  );
}
